import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type.ts";
import type { NotebookMessage } from "@notebook/domain/models/notebook-message.model";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookMessageGetByIdUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookMessageRepository)
        private readonly notebookMessageRepository: NotebookMessageRepository,
    ) {}

    async execute(
        notebookMessageId: string,
        notebookId: string,
    ): Promise<Nullable<NotebookMessage>> {
        const notebookMessageResult =
            await this.notebookMessageRepository.fetchById(
                notebookMessageId,
                notebookId,
            );

        if (notebookMessageResult.isErr()) {
            ToastManagerRepository.error(notebookMessageResult.error.message);
        }
        return notebookMessageResult.match(
            (notebookMessage) => notebookMessage,
            () => null,
        );
    }
}
